const StarIcon = ({ strokeColor = '#808080' }) => (
  <svg
    viewBox="0 0 795.1 795.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>{`
        .cls-1 { fill: #4d4d4d; }
        .cls-2 {
          stroke: ${strokeColor};
          stroke-width: 50px;
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-3 {
          stroke: #fff;
          stroke-width: 20px;
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-4 { fill: #fdfdfd; }
      `}</style>
    </defs>

    <g>
      <circle className="cls-1" cx="397.55" cy="397.55" r="388.66" />
      <circle className="cls-2" cx="397.55" cy="397.55" r="372.55" />
      <circle className="cls-3" cx="397.55" cy="397.55" r="343.4" />
    </g>

    <g>
      <path className="cls-4" d="M198.26,321.09h138.52c7.72-24.61,15.45-49.07,23.04-73.56,6.99-22.55,13.74-45.17,20.75-67.71,2.42-7.77,5.5-15.05,15.57-15.35,10.44-.31,14.29,6.96,16.92,14.96,14.45,44.01,28.84,88.04,42.78,132.21,2.3,7.3,5.4,9.74,13.24,9.66,44.15-.45,88.31-.21,132.47-.21,1.53,0,3.07-.05,4.6,0,10.14.36,18.56,5.77,20.47,13.86,2.12,8.99-2.62,15.3-9.43,20.26-15.78,11.49-31.68,22.82-47.5,34.25-22.98,16.62-45.94,33.27-69.27,50.17,12.39,38.38,24.77,76.61,37.07,114.86,3.71,11.53,6.9,23.24,10.93,34.65,3.05,8.66-.06,15.24-6.3,20.31-6.71,5.45-14.18,3.11-20.37-1.3-19.13-13.64-37.95-27.73-56.9-41.62-20.68-15.16-41.51-30.12-61.98-45.58-4.61-3.48-7.53-3.25-11.94.04-37.2,27.77-74.54,55.33-111.91,82.87-3.16,2.33-6.72,5.65-10.15,5.72-5.71.12-14.33-.2-16.53-3.64-3.41-5.35-4.71-14.11-2.97-20.32,8.15-29.16,17.6-57.96,26.69-86.86,5.36-17.03,10.51-34.15,16.63-50.91,2.32-6.35.5-8.98-4.38-12.52-35.85-25.98-71.5-52.23-107.15-78.47-11.84-8.71-15.39-15.56-11.92-24.12,4.28-10.55,13.43-12.27,23.52-11.68,1.53.09,3.07.01,5.5.02ZM295.33,553.04c27.98-20.71,55.96-41.42,83.95-62.12,15.32-11.33,20.21-11.35,35.71-.09,29.31,21.3,58.6,42.63,89.5,65.11-12.07-38.14-23.55-74.44-35.03-110.73-4.05-12.81-2.15-18.91,8.56-26.8,14.01-10.32,28.08-20.57,42.1-30.88,15.27-11.24,30.52-22.53,47.61-35.15h-109.07c-18.52,0-22.8-3.27-28.72-21.29-10.55-32.09-21.21-64.15-32.22-97.43-1.16,2.83-1.97,4.44-2.5,6.14-9.95,32.09-19.79,64.22-29.84,96.28-3.45,11.01-10.97,16.24-22.48,16.29-8.89.04-17.79,0-26.68,0h-88.21c2.91,2.4,4.14,3.52,5.47,4.49,28.05,20.62,56.12,41.23,84.19,61.84,10.15,7.46,12.38,14.07,8.67,25.91-11.23,35.83-22.48,71.66-34.16,108.39.14.47.29.94.43,1.4.49-.39.98-.78,2.72-1.39Z" />
    </g>
  </svg>
);

export default StarIcon;